import { render, staticRenderFns } from "./Expander.vue?vue&type=template&id=8a24037a&scoped=true"
import script from "./Expander.vue?vue&type=script&lang=js"
export * from "./Expander.vue?vue&type=script&lang=js"
import style0 from "./Expander.vue?vue&type=style&index=0&id=8a24037a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a24037a",
  null
  
)

export default component.exports